"use client"

import Text from "@/components/common/Typography/Text"
import PhoneIcon from "@/components/icons/PhoneIcon"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Card, Col, Modal, Row } from "antd"
import { useTranslation } from "react-i18next"

const Hotline = () => {
  const isDesktop = useIsDesktop()
  const [modal, modalCtx] = Modal.useModal()
  const { t } = useTranslation()

  if (isDesktop) {
    return (
      <Card
        className="hotline"
        variant='borderless'
        hoverable
        onClick={() => { window.location.href = `tel:${process.env.NEXT_PUBLIC_COMPANY_PHONE || ""}`; }}
      >
        <Row align='middle' justify='space-between' gutter={[6, 6]}>
          <Col>
            <Row align='middle'>
              <PhoneIcon className="hotline__icon" />
            </Row>
          </Col>
          <Col>
            <Row>
              <Text className="hotline__label">
                Hotline: <Text className="hotline__number">{process.env.NEXT_PUBLIC_COMPANY_PHONE || ""}</Text>
              </Text>
            </Row>
            <Row>
              <Text className="hotline__label">
                {t("home.working_hours")}: <Text strong>07:00 - 23:00</Text>
              </Text>
            </Row>
          </Col>
        </Row>
      </Card>
    )
  }

  return (
    <>
      {modalCtx}
      <Card
        className="hotline"
        variant='borderless'
        hoverable
        onClick={() => {
          if (!isDesktop) {
            modal.confirm({
              icon: <PhoneIcon className="hotline__icon" />,
              title: `${t("app.CSKH")}: ${process.env.NEXT_PUBLIC_COMPANY_PHONE || ""}`,
              content: t("app.hotline_message", { timeline: "07:00 - 23:00" }),
              okText: t("app.call_now"),
              onOk: () => {
                window.location.href = `tel:${process.env.NEXT_PUBLIC_COMPANY_PHONE || ""}`;
              }
            })
          }
        }}
      >
        <Row align='middle' justify='space-between' gutter={[6, 6]}>
          <Col>
            <Row align='middle'>
              <PhoneIcon className="hotline__icon" />
            </Row>
          </Col>
          <Col>
            <Row>
              <Text className="hotline__label">
                Hotline{isDesktop && `: 06:00 - 23:59`}
              </Text>
            </Row>
            <Row>
              <Text className="hotline__number">
                {process.env.NEXT_PUBLIC_COMPANY_PHONE || ""}
              </Text>
            </Row>
          </Col>
        </Row>
      </Card>
    </>
  )
}

export default Hotline